import cn from 'helpers/classnames'
import React from 'react'
import s from './styles.module.css'

export default function Sky() {
  return <div className={cn('pointer-events-none', s.sky)} />
}
